import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { CsBrokerTradeToolService } from '../../services/wealthlane-award-services/services/CsBrokerTradeToolService';
import { Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto } from '@/services/wealthlane-award-services/models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto';

const useSubmitBrokerAssist = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: Wealthlane_AwardService_Dtos_BrokerTradeTool_CsSubmitRowDto) => {
      return await handleRequest(
        CsBrokerTradeToolService.postApiAwardApiAppCsBrokerTradeToolSubmit(data)
      );
    },
    {
      onSuccess: () => {
        toast.success(
          <ToastComponent label='Success' message='Broker-Assisted order submitted successfully.' />
        );
        void queryClient.invalidateQueries('getCsTransactionHistory');
        void queryClient.invalidateQueries('getCsSellItems');
        onSuccess?.();
      },
    }
  );
};

export default useSubmitBrokerAssist;
